import { Modal } from "antd";

export default function DetailsModal({ setDetailsModal, detailsModal, businessDetails }) {
  return (
    <Modal
      visible={detailsModal}
      onCancel={() => setDetailsModal(false)}
      footer={null}
      title="Business Details"
    >
      <div>
        <b>Complete Address:</b> {businessDetails.address}<br /><br />
        <b>Url:</b> <a href={`https://maps.google.com/?q=${businessDetails.lat},${businessDetails.long}`} target="_blank" rel="noopener noreferrer">{`https://maps.google.com/?q=${businessDetails.lat},${businessDetails.long}`}</a>
      </div>
    </Modal>
  );
}